// Generated by `bun run samples:generate`. Do not edit.
import url1 from '../../../../assets/samples/falcons-navi-anubis.disa.gz?url';
import url0 from '../../../../assets/samples/falcons-navi-inferno.disa.gz?url';
import type { SampleId } from '../helpers/catalogue';

export interface SampleAsset {
  url: string;
  /** The compressed size, which is what a reader is told a press will cost. */
  byteLength: number;
}

/**
 * Where each sample's bytes are, and how big they are on the wire — written by
 * `bun run samples:generate`, and held to the files on disk by `bun run samples:check`.
 *
 * The URL is Vite's: a container is imported with `?url`, so it is emitted into `/assets/` with a
 * content hash and served under the `immutable` rule in `apps/web/public/_headers` like every other
 * hashed asset. It is **not** in the service worker's precache — `globPatterns` is `html,css,js` —
 * which is what keeps a reader who came with their own demo from paying for any of it.
 *
 * The record is keyed by `SampleId`, so a sample the catalogue names and nobody shipped bytes for
 * is a compile error rather than a card that answers a press with a failure.
 */
export const SAMPLE_ASSETS: Record<SampleId, SampleAsset> = {
  'falcons-navi-inferno': { url: url0, byteLength: 3927849 },
  'falcons-navi-anubis': { url: url1, byteLength: 6130565 },
};
